import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ChartModule } from "primeng/chart";
import { DialogModule } from "primeng/dialog";
import { QuarterlySupportTableComponent } from "../quarterly-support-table/quarterly-support-table.component";

@Component({
  selector: "jni-tiger-level-gp-chart",
  templateUrl: "./tiger-level-gp-chart.component.html",
  styleUrls: ["./tiger-level-gp-chart.component.scss"],
  imports: [
    DialogModule,
    ChartModule,
    CommonModule,
    QuarterlySupportTableComponent,
  ],
})
export class TigerLevelGpChartComponent implements OnInit {
  data!: {
    labels: string[];
    datasets: {
      label?: string;
      backgroundColor?: string;
      borderColor?: string;
      data: number[];
      type: string;
      borderWidth: number;
      fill?: boolean;
      tension?: number;
    }[];
  };

  visible = false;

  options!: {
    maintainAspectRatio: boolean;
    aspectRatio: number;
    plugins: {
      legend: {
        labels: {
          color: string;
        };
      };
    };
    scales: {
      x: {
        ticks: {
          color: string;
        };
        grid: {
          color: string;
        };
      };
      y: {
        ticks: {
          color: string;
        };
        grid: {
          color: string;
        };
      };
    };
  };

  ngOnInit() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    this.data = {
      labels: ["3 Month GP", "6 Month GP", "9 Month GP", "12 Month GP"],

      datasets: [
        {
          type: "line",

          label: "Support",

          borderColor: documentStyle.getPropertyValue("--blue-500"),

          borderWidth: 2,

          fill: false,

          tension: 0.4,

          data: [212500, 212500, 212500, 212500],
        },
        {
          type: "bar",

          label: "Approx. Billed GP/Month",

          backgroundColor: documentStyle.getPropertyValue("--green-500"),

          data: [106250, 212500, 318750, 425000],

          borderColor: "white",

          borderWidth: 2,
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };
  }

  showDialog() {
    this.visible = true;
  }
}
